import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		opentoworkStatus: Grabcad.member_open_to_work || false,
		opentoworkTooltipSeen:
			Grabcad.member_seen_available_for_work_tooltip && true,
		opentoworkDialogVisible: false
	},
	mutations: {
		toggleOpentoworkDialog(state) {
			state.opentoworkDialogVisible = !state.opentoworkDialogVisible;
		},
		hideOpentoworkDialog(state) {
			state.opentoworkDialogVisible = false;
		}
	},
	actions: {
		async toggleOpentoworkStatus({ state }) {
			await axios.post("/profile/available_for_work_toggle");
			state.opentoworkStatus = !state.opentoworkStatus;
			Grabcad.member_open_to_work = state.opentoworkStatus;
		},
		async markOpentoworkTooltipAsSeen({ state }) {
			await axios.post("/profile/has_seen_available_for_work_tooltip");
			state.opentoworkTooltipSeen = true;
			Grabcad.member_seen_available_for_work_tooltip = true;
		}
	}
});

Grabcad = Grabcad || {};
Grabcad.opentoworkStore = store;

export default store;
